<template>
  <div class="SellingCar">
    <HeaderTop/>
    <div class="w">
      <div class="container">
        <div class="container-top">
          <div class="container-bg">
            <h3>责任速度<em></em>优质价格</h3>
            <ul>
              <li><i class="iconfont icon-SVG-"></i>买家竞价购车</li>
              <li><i class="iconfont icon-SVG-"></i>最快1天极速卖车</li>
              <li><i class="iconfont icon-SVG-"></i>全程服务0费用</li>
            </ul>
            <div class="container-top-mess" >
              <el-form ref="form" :model="form" :rules="rules" @keydown.enter.native="onSubmit">
                <el-form-item>
                  <select v-model="form.location" @change="getCouponSelected">
                    <option v-for="(item, index) in locationArr" :key="index" :value="item.name">{{item.name}}</option>
                  </select>
                </el-form-item>
                <el-form-item prop="phoneNo"> 
                  <input type="text" prefix="md-person" v-model="form.phoneNo" placeholder="请输入您的手机号码"  size="large" :maxlength="11"/>
                </el-form-item>
                <el-form-item>
                  <input @click="onSubmit($event)" type="button" value="我要卖车"/>
                </el-form-item>  
              </el-form>
            </div>
          </div>
        </div>
        <!-- <div class="container-top-mess-model">
          <form action="">     
            <select>
              <option value="深圳">深圳</option>
              <option value="广州">广州</option>
              <option value="东莞">东莞</option>
              <option value="佛山">佛山</option>
            </select>
            <input type="text" placeholder="请输入您的手机号码"/>
            <input type="button" value="我要卖车"/>
          </form>
        </div> -->
        <div class="container-bottom">
          <h4>— 卖车流程 —</h4>
          <div class="container-bottom-process">
            <span><i class="icon"></i>1.提交信息</span>
            <span><i class="icon"></i>2.现场看车</span>
            <span><i class="icon"></i>3.获得报价</span>
            <span><i class="icon"></i>4.完成交易</span>
          </div>
        </div>
      </div>
      <FooterAbout/>
    </div>
    <Copy/>
  </div>
</template>

<script>
import { reqAddSaleUser } from '../api'
import { isPhone } from '../js/validate.js'
import HeaderTop from '../components/HeaderTop.vue'
import FooterAbout from '../components/FooterAbout.vue'
import Cookies from 'js-cookie'
import Copy from '../components/Copy.vue'

export default {
  name: 'SellingCar',
  data () {
    return {
      locationArr: [
        {name: '深圳', moName: 'sz'},
        {name: '广州', moName: 'gz'},
        {name: '东莞', moName: 'dg'},
        {name: '佛山', moName: 'fs'},
        {name: '肇庆', moName: 'zq'}
      ],
      form: {
        phoneNo: '',
        location: '',
        position: Cookies.get('position') || 2
      },
      rules:{
        phoneNo: [
          { required: true, message: '请输入正确的手机号码', trigger: 'blur' },
          { type: 'string', min: 11, message: '手机号不允许小于11位', trigger: 'blur' },
          { validator: isPhone, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.form.location = this.locationArr[0].name
  },
  methods: {
    getCouponSelected(){
      console.log(this.form.location)
    },
    onSubmit(event) {
      event.preventDefault()
      let formData = this.form
      console.log('formData', formData)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          reqAddSaleUser(formData).then( res => {
            if (res.status) {
              console.log('提交成功')
              this.$message({
                message: "提交成功！",
                customClass: 'mode',
                type: 'success'
              })
              console.log('reqAddSaleUser',formData)
              // this.$router.back(-1)
            } else {
              this.$message({
                message: "提交失败，请填写对应的内容！",
                customClass: 'mode',
                type: 'error'
              })
              return false
            }
            this.$nextTick(() => {
              this.$refs.form.resetFields()
              this.form.phoneNo = ''
            })
          })
        } else {  
          this.$message({
            message: "添加失败，请填写对应的内容！",
            customClass: 'mode',
            // duration: 300000,
            type: 'error'
          })
        }
      })
    }
  },
  components: {
    HeaderTop,
    FooterAbout,
    Copy
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .SellingCar >>> .el-form-item
    margin-bottom 0
    float left
    .el-form-item__content .el-form-item__error
      margin 4px 0 0 16px
  .SellingCar
    .container
      width 100%
      text-align center
      margin-top 26px
      .container-top
        color #fff
        padding 160px 0
        background-image url(../images/sellingcars.jpg)
        background-repeat no-repeat
        background-size cover
        position relative
        .container-bg
          width 100%
          height 100%
          position absolute
          top 0
          left 0
          z-index 2
          background rgba(0,0,0,0.63)
          display flex
          flex-direction column
          justify-content center
          ul
            li
              font-size 18px
              display inline-block
              margin 0 16px
              i
                margin-right 4px
          h3
            font-family sans-serif
            font-size 46px
            font-weight 600
            padding-bottom 20px
            em
              display inline-block
              margin 0 20px
          .container-top-mess
            width 100%
            margin-top 20px
            display flex
            justify-content center
            select,input
              font-size 20px
              height 50px
              vertical-align top
              padding 0 6px
              float left
            select
              width 100px
            input[type="text"]
              width 370px
              margin 0 0 0 16px
              padding-left 16px
              color #999
              .color
                color #fff
            input[type="button"]
              width 160px
              height 51px
              margin 0 0
              font-weight 600
              color #fff
              background #d81240
              cursor pointer
      .container-top-mess-model
        select
          width 200px
          height 36px
          display block
        input 
          width 300px
          height 36px
          display block
      .container-bottom
        margin-top 36px
        h4
          font-size 20px
        .container-bottom-process
          padding 58px
          span
            font-size 16px
            width 24%
            display inline-block
            .icon
              display block
              width 46px
              height 46px
              margin 0 auto 30px
              background url(../images/icon.png) no-repeat
              background-size 100px
              background-position -54px 0
            &:nth-of-type(2) .icon
              background-position -54px -46px
            &:nth-of-type(3) .icon
              background-position -53px -92px
            &:nth-of-type(4) .icon
              background-position -54px -138px
  @media screen and (min-width: 660px) and (max-width: 710px) 
    .SellingCar .container .container-top .container-bg .container-top-mess
      input[type="text"]
        width 330px
  @media screen and (min-width: 590px) and (max-width: 659px)   
    .SellingCar .container .container-top .container-bg .container-top-mess
      input[type="text"]
        width 270px
  @media screen and (min-width: 510px) and (max-width: 589px)   
    .SellingCar .container 
      .container-top .container-bg 
        h3
          font-size 36px
        ul li
          font-size 16px
        .container-top-mess
          input[type="text"]
            width 200px
      .container-bottom
        .container-bottom-process
          padding 30px
  @media screen and (min-width: 510px) and (max-width: 589px)   
    .SellingCar .container 
      .container-top .container-bg 
        h3
          font-size 36px
        ul li
          font-size 16px
        .container-top-mess
          input[type="text"]
            width 200px
      .container-bottom
        .container-bottom-process
          padding 20px
  @media screen and (min-width: 100px) and (max-width: 509px)
    .SellingCar .container 
      .container-top 
        padding 230px 0
        .container-bg 
          h3
            font-size 36px
            padding-bottom 20px
          ul li
            width 100%
            font-size 16px
            text-align left 
            margin 0 0 10px 12%
          .container-top-mess
            margin-top 0
            form
              width 80%
            input[type="text"]
              width 200px
            .el-form-item
              float none
              margin 16px 0
              & >>> .el-form-item__content
                text-align left
                select
                  width 80%
                  float none
                  font-size 18px
                input[type="text"]
                  width 80%
                  margin 0
                input
                  font-size 18px
      .container-bottom
        .container-bottom-process
          padding 10px
  @media screen and (min-width: 100px) and (max-width: 330px)
    .SellingCar .container 
      .container-top .container-bg 
        h3
          font-size 30px
</style>


// WEBPACK FOOTER //
// src/pages/SellingCar.vue